// extracted by mini-css-extract-plugin
export var component = "Quote-module--component--85UM3";
export var blockquote = "Quote-module--blockquote--449BG";
export var heading = "Quote-module--heading--J4Nkx";